
    <template>
        <div class="school-grid">
            <div class="school-item" v-for="school in schools" :key="school.schoolCode" @click="showSchoolSite(school.schoolCode)">
                <img :src="school.schoolIcon" :alt="school.name" class="school-image" />
                <div class="school-info">
                  <span class="school-name">{{ school.schoolName }}</span>
                </div>
            </div>
        </div>
    </template>


  
  <script>
  export default {
    props:{
    productId:String
  },
    data() {
      return {
        schools: [
          // ... 添加更多商品数据
        ],
      };
    },
    mounted(){
      this.getSchool();
    },
    methods: {
      addToCart(product) {
        // 处理添加到购物车的逻辑
        console.log('商品已添加到购物车:', product);
      },
      showSchoolSite(code){
        this.$emit('getBack','sch_'+code)
      },
      getSchool(){
        this.postRequest('/yl/site/getSchool', {}).then(resp => {
            if (resp) {
                this.schools = resp.data;
            }
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .school-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 20px;
  }
  
  .school-item {
    flex: 0 0 12%; /* 控制每个商品项的宽度，这里设置为24%，可根据需要调整 */
    margin-bottom: 10px; /* 商品项之间的间距 */
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .school-image {
    width: 60%;
    height: auto;
    display: block;
  }
  
  .school-info {
    height: 30px;
    width: 100%;
    padding: 10px;
  }
  
  .add-to-cart-btn {
    display: block;
    margin: auto;
    padding: 10px;
    background-color: #4CAF50; /* 按钮背景色 */
    color: white; /* 按钮文字颜色 */
    border: none;
    cursor: pointer;
  }
  
  .add-to-cart-btn:hover {
    background-color: #45a049; /* 鼠标悬停时的背景色 */
  }
  .school-name{
    font-size: 20px;
    font-weight: 550;
  }
  </style>